<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium"
            >{{ $t('ITEM.EDIT') }} {{ $t('FORMS.ITEM') }}</span
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card v-if="error" tile class="mt-5">
      <v-alert
        v-for="(e, index) in error.data.errors"
        :key="index"
        tile
        color="error"
        dark
        dense
        >{{ e[0] }}
      </v-alert>
    </v-card>

    <v-card v-if="Object.keys(localform).length" tile class="pa-5 mt-4">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-row>
          <v-col cols="10">
            <app-content-tabs
              v-if="Object.keys(localform).length"
              v-model="localform"
              form-path="modules/forms/components/FormForm.vue"
            ></app-content-tabs>
          </v-col>
          <v-col cols="2">
            <v-row>
              <v-checkbox
                v-model="localform.is_active"
                flat
                :label="
                  `${$t('STATUS.ACTIVE')}: ${
                    localform.is_active === 1
                      ? $t('TRUE')
                      : localform.is_active === 0
                      ? $t('FALSE')
                      : $t(localform.is_active.toString().toUpperCase())
                  }`
                "
              ></v-checkbox>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            :disabled="!valid"
            elevation="24"
            large
            color="success"
            >{{ $t('BUTTON.SAVE') }}</v-btn
          >
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'FormEditPage',

  components: {
    AppContentTabs: () =>
      import('@/modules/app_content/components/AppContentTranslationTabs.vue')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      error: null,
      valid: true,
      localform: {},
      copyLocalform: null
    };
  },

  created() {
    this.setData();
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('form/update', this.localform)
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.$router.push({ name: 'forms' });
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    },

    setData() {
      this.$store
        .dispatch('form/retrieve', this.id)
        .then(({ data }) => {
          this.form = data;
          this.localform = cloneDeep(this.form);
          this.copyLocalform = cloneDeep(this.form);
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    }
  }
};
</script>
